export const licensePriceCents = (songCount: number): number => {
	if (songCount <= 0) {
		return 0;
	}

	if (songCount === 1) {
		return 3000;
	}

	if (songCount === 2) {
		return 5000;
	}

	return 2000 * songCount;
};

export const formatLicensePrice = (cents: number): string => {
	return `$${(cents / 100).toFixed(2)}`;
};
